export default __webpack_public_path__ + "static/media/Terminator's Dreadmaul.53305fd3.jpg";